<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9617_145689)">
<path d="M0.5 0V24H4.30009L6.70009 23.1999L22.9001 24L23.3 17.4L24.5 17.0001V0H0.5Z" fill="#0E0FE0"/>
<path d="M7.69183 5.62793H13.2877C16.2105 5.62793 18.6165 6.4121 18.6165 9.76271C18.6165 13.2735 16.0146 14.3963 12.3789 14.3963H10.4899L9.83043 18.1032H5.5L7.69183 5.62793ZM12.201 11.3665C13.4842 11.3665 14.1791 11.0457 14.1791 9.86967C14.1791 8.87184 13.5554 8.69341 12.6285 8.69341H11.488L11.0244 11.3665H12.201Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_9617_145689">
<rect width="24" height="24" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
